"use client";
import * as React from "react";

import { RejectMatchFormContainer } from "@/app/(discover)/candidate/invites/components/reject-match-modal/reject-match-form";
import { RejectMatchModalView } from "@/app/(discover)/candidate/invites/components/reject-match-modal/reject-match-view";

export default function RejectMatchModal({
  onClose,
  onSubmitSuccess,
  schoolNcesId,
}: {
  onClose: () => void;
  onSubmitSuccess: () => void;
  schoolNcesId: string;
}) {
  return (
    <RejectMatchModalView
      onClose={onClose}
      formEl={
        <RejectMatchFormContainer
          onSubmitSuccess={onSubmitSuccess}
          onCancel={onClose}
          schoolNcesId={schoolNcesId}
        />
      }
    />
  );
}
